module.exports = __webpack_public_path__ + "img/us.b1914370.svg";